import React from 'react';
import { ButtonV2, Flex, TextV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { useTranslation } from '@shared/core';
import { ListIcon } from '@assets/index';

type ListButtonProps = Readonly<{
  onClick: () => void;
}>;

export const ListButton: React.FC<ListButtonProps> = ({ onClick }) => {
  const { tq } = useTranslation('accommodationsConsole');

  return (
    <ButtonV2
      paddingX={0}
      height={pxToRem(40)}
      backgroundColor="transparent"
      _hover={{ backgroundColor: 'transparent' }}
      _active={{ backgroundColor: 'transparent' }}
      onClick={onClick}
    >
      <Flex
        alignItems="center"
        gap={2}
        border="1px solid"
        borderColor="mono3"
        borderRadius="full"
        paddingX={5}
        paddingY={pxToRem(10)}
        color="mono14"
        boxShadow="0px 3px 8px 0px rgba(0, 0, 0, 0.03), 0px 10px 60px -20px rgba(44, 41, 37, 0.03), 0px 9px 36px -30px rgba(0, 0, 0, 0.04);"
        position="relative"
        backgroundColor="white"
      >
        <ListIcon
          width={pxToRem(18)}
          height={pxToRem(16)}
        />
        <TextV2 typographyVariant="label2">{tq`List`}</TextV2>
      </Flex>
    </ButtonV2>
  );
};
